<template>
  <div>
    <h1>AIでんわ発番作業ウィザード</h1>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        paylight Call 商談ID
        <input class="form-control" type="text" placeholder="paylight Call 商談ID" v-model="sfOpportunityId" />
        <button class="btn btn-other-action" @click="loadSfOpportunity">SFから読み込み</button>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        Notionコピー項目
        <input class="form-control" type="text" placeholder="Notionコピー項目（タブ区切り）" v-model="notionInput" />
        <button class="btn btn-other-action" @click="loadShopId">Notion情報から読み込み</button>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        SHOP ID
        <input class="form-control" type="text" placeholder="SHOP ID" v-model="shopId" />
        <button class="btn btn-other-action" @click="loadByShopId">Shop IDから読み込み</button>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        申込日
        <input class="form-control" type="text" placeholder="申込日yyyy-mm-dd" v-model="appDate" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        Notion 医院名
        <input class="form-control" type="text" placeholder="Notion 医院名" v-model="notionName" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        TURTLE 医院名
        <input class="form-control" type="text" placeholder="TURTLE 医院名" v-model="name" readonly />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        呼び名
        <input class="form-control" type="text" placeholder="呼び名" v-model="nameRuby" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        サクセス担当者
        <input class="form-control" type="text" placeholder="サクセス担当者" v-model="follow" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        AIオペレータ
        <select id="operator" class="form-control" v-model="selectedOperator">
          <option disabled value="">AIオペレータを選択</option>
          <option v-for="operator in operators" :key="operator.name" :value="operator.name">
            {{ operator.name }}
          </option>
        </select>
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        作業カテゴリ
        <input class="form-control" type="text" placeholder="作業カテゴリ" v-model="requestCategory" readonly />
      </div>
    </div>

    <div class="row" style="display: none">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="SF取引先より、取引先情報>電話" v-model="phone" />
      </div>
      <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="SF取引先より、住所情報>住所を都道府県からスペースなし" v-model="address" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="開始希望日yyyy-mm-dd" v-model="startHopeDate" />
      </div>
    </div>




    <div class="row" style="display: none">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <select id="plan" class="form-control" v-model="selectedPlan">
          <option disabled value="">プランを選択</option>
          <option v-for="plan in plans" :key="plan.title" :value="plan.title">
            {{ plan.title }}
          </option>
        </select>
      </div>
    </div>

    <div class="row" style="display: none">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6" v-for="(option, idx) in options" :key="idx">
        <input type="checkbox" :id="'option_' + idx" v-model="checkedOptions[idx]" />
        <label :for="'option_' + idx">{{ option.title }}</label>
      </div>
    </div>

    <div v-if="currentStep === 0 && requestCategory === '新規開設'">
      <h2>1. 事前確認</h2>
      <div v-if="aiCallPlanStatus === 'active'" class="alert alert-warning">
        <strong>paylight Call 稼働中の契約あり</strong>（契約ID: <a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">{{ aiCallContractId }}</a>、プラン期間: {{ aiCallPlanStartDate }} 〜 {{ aiCallPlanEndDate || '未定' }}）
        <p>新規開設ではなくCallからの移行と思われるので、切り替えタイミングを正確に確認する必要あり。</p>
        <p style="color: red; font-weight: bold;">※契約切替日が過去日の場合、同期バッチの制御が必要になりますので、Inhouseまでお声がけください。</p>
        <p style="margin-top: 10px;" v-html="callCenterTransferCheckHtml"></p>
        <p>以下コメントを添えてサクセスへ差し戻し</p>
        <textarea readonly :value="callMigrationNoticeTxt" class="form-control" rows="8"></textarea>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(callMigrationNoticeTxt)" />
        <br/>
        <div v-html="callCenterSettingNoticeHtml"></div>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(callCenterSettingNoticeTxt)" />
        <p style="margin-top: 10px;" v-html="sfCallCheckHtml"></p>
      </div>
      <div v-else-if="aiCallPlanStatus === 'ended'" class="alert alert-info">
        <strong>paylight Call 終了済みの契約あり</strong>（契約ID: <a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">{{ aiCallContractId }}</a>、プラン期間: {{ aiCallPlanStartDate }} 〜 {{ aiCallPlanEndDate }}）
        <p>Call契約時に使用していた発番番号、及びシナリオを再利用して良いか確認する必要あり。<br/>
          シナリオのバージョンが古い場合は、シナリオのみ新規作成となるパターンが多いので、commuboの<a href="https://console.commubo.com/scenarios" target="_blank">会話シナリオ一覧</a>よりShopIDで検索>詳細・削除より、最新のシナリオのバージョンを確認する。</p>
        <p style="margin-top: 10px;" v-html="callCenterTransferCheckHtml"></p>
        <p>以下コメントを添えてサクセスへ差し戻し</p>
        <textarea readonly :value="callEndedNoticeTxt" class="form-control" rows="3"></textarea>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(callEndedNoticeTxt)" />
        <br/>
        <div v-html="callCenterSettingNoticeHtml"></div>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(callCenterSettingNoticeTxt)" />
      </div>
      <div v-else class="alert alert-success">
        <strong>paylight Call 契約なし</strong>
      </div>
        <li v-if="settingCallCenterTransfer !== checkedOnCallCenterTransfer">
          コールセンター転送は実施するのか、しないのか
        </li>
        <li v-if="checkedOnLine || checkedOnSms">
          CXの契約確認（CXと期間の重複したLINE,SMSオプションはNG）
        </li>
        <li v-if="checkedOnLine && !checkedOnSms">
          LINEやる場合はSMSもセットになる（SMSやる場合にLINEは必須ではない）
        </li>
      </ol>
    </div>

    <div v-else-if="currentStep === 0 && requestCategory === 'Callからの移行'">
      <h2>1. 事前確認</h2>
      <div v-if="aiCallPlanStatus === 'active'" class="alert alert-warning">
        <strong>paylight Call 稼働中の契約あり</strong>（契約ID: <a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">{{ aiCallContractId }}</a>、契約期間: {{ aiCallPlanStartDate }} 〜 {{ aiCallPlanEndDate || '未定' }}）
        <p style="color: red; font-weight: bold;">※契約切替日が過去日の場合、同期バッチの制御が必要になりますので、Inhouseまでお声がけください。</p>
        <p style="margin-top: 10px;" v-html="callCenterTransferCheckHtml"></p>
        <br/>
        <div v-html="callCenterSettingNoticeHtml"></div>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(callCenterSettingNoticeTxt)" />
        <p style="margin-top: 10px;" v-html="sfCallCheckHtml"></p>
      </div>
      <div v-else-if="aiCallPlanStatus === 'ended'" class="alert alert-info">
        <strong>paylight Call 終了済みの契約あり</strong>（契約ID: <a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">{{ aiCallContractId }}</a>、契約期間: {{ aiCallPlanStartDate }} 〜 {{ aiCallPlanEndDate }}）
        <p style="margin-top: 10px;" v-html="callCenterTransferCheckHtml"></p>
        <br/>
        <div v-html="callCenterSettingNoticeHtml"></div>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(callCenterSettingNoticeTxt)" />
      </div>
      <div v-else class="alert alert-success">
        <strong>paylight Call 契約なし</strong>
        <p>Callからの移行でなく新規開設と思われるので、サクセスに確認する必要あり。<br/>以下コメントを添えてサクセスへ差し戻し</p>
        <textarea readonly :value="newContractConfirmNoticeTxt" class="form-control" rows="3"></textarea>
        <input type="button" value="コピー" class="btn btn-other-action" @click="copy(newContractConfirmNoticeTxt)" />
      </div>
    </div>

    <div v-else-if="currentStep === 0">
      <h2>1. 事前確認</h2>
      <div v-if="aiCallPlanStatus === 'active'" class="alert alert-warning">
        <strong>paylight Call 稼働中の契約あり</strong>（契約ID: <a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">{{ aiCallContractId }}</a>、プラン期間: {{ aiCallPlanStartDate }} 〜 {{ aiCallPlanEndDate || '未定' }}）
        <p style="margin-top: 10px;" v-html="callCenterTransferCheckHtml"></p>
        <p style="margin-top: 10px;" v-html="sfCallCheckHtml"></p>
      </div>
      <div v-else-if="aiCallPlanStatus === 'ended'" class="alert alert-info">
        <strong>paylight Call 終了済みの契約あり</strong>（契約ID: <a :href="`/manage/store_ai_call_contracts/${aiCallContractId}/workflows/new`" target="_blank">{{ aiCallContractId }}</a>、プラン期間: {{ aiCallPlanStartDate }} 〜 {{ aiCallPlanEndDate }}）
        <p style="margin-top: 10px;" v-html="callCenterTransferCheckHtml"></p>
      </div>
      <div v-else class="alert alert-success">
        <strong>paylight Call 契約なし</strong>
      </div>
      <p v-if="requestCategory" style="color: red; font-weight: bold;">依頼カテゴリが「{{ requestCategory }}」です。対応する作業フローがありません。</p>
    </div>

    <div v-if="currentStep === 1">
      <h2>2. X契約の管理スプシに記載</h2>
      <ol>
        <li>
          以下の契約医院リスト用テキストをコピーし、<a href="https://docs.google.com/spreadsheets/d/1UC-Mm48VvhxGKSBGlHKkGQdCX_pnq6xsKBynfSh-7xg/edit?gid=1468851759#gid=1468851759&range=A87" target="_blank">X契約の管理スプシ</a>に貼り付ける
          <div class="row" style="margin-top: 10px;">
            <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <input class="form-control" type="text" placeholder="paylight X 契約医院リスト用テキスト" v-model="contractSpreadsheet" />
              <input type="button" value="コピー" class="btn btn-other-action" @click="copy(contractSpreadsheet)" />
            </div>
          </div>
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 2">
      <h2>3. v1シナリオ作成</h2>
      <ol>
        <li>
          Commuboの左メニュー>会話シナリオを選択
        </li>

        <li>
          以下のシナリオの「詳細・削除」を押し、<br>
          バージョンのバックナンバー一覧から「適用中」のもので「新規シナリオに複製」を押す<br>
          <table class="table table-striped">
            <thead>
            <tr>
              <th>シナリオ名</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>★【カレンダー連携】gpt医院名＋OLショップID＋プラン名</td>
            </tr>
            </tbody>
          </table>
        </li>

        <li>
          会話シナリオ名は
          <div class="row">
            <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <input class="form-control" type="text" readonly :value="scenarioName" />
              <input type="button" value="コピー" class="btn btn-other-action" @click="copy(scenarioName)" />
            </div>
          </div>
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 3">
      <h2>4. 会話シナリオデータ編集</h2>
      <ol>
        <li>
          会話シナリオより、「会話シナリオデータを編集」を押し、<br>
          DFD（とは違うか）の左端の方にある「医院情報設定」を押す
        </li>

        <li>
          コンテキストごとに登録できる文字を指定できるため、以下を入力する
          <ul>
            <li>hospital_name：{{ name }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(name)" /></li>
            <li v-if="checkedOnCallCenterTransfer">transfer：{{ checkedOnCallCenterTransfer === true ? 'yes' : '' }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy('yes')" /></li>
          </ul>
        </li>

        <li>
          「AIオペレータ発話を追加」を押し、テキストボックスに医院名を入力して「発話音声をプレビュー」<br>
          それが<strong>{{ nameRuby }}</strong>と一致するか、イントネーションや発音が正しいか確認する<br>
          調整は<a href="https://www.notion.so/kitchen-drunkard/Call-1dca07dfe79680edbe96dd36ccaaede1?source=copy_link#1dca07dfe7968057ab66f36f961a0c06" target="_blank">notion</a>を参照<br>
          調整の結果をspeak_hospital_nameに記述して、<strong>必ず「AIオペレータの発話」を削除する</strong>
        </li>

        <li>
          以上の登録ができたら「OK」を押し、<br>
          画面の右上より、「バージョン登録して保存」を押す<br>
          バージョンはシナリオ作成でもとにしたテンプレートのメジャーバージョンを使う<br>
          つまり、5.0.50ならば5.0.0を指定する
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy('5.0.0')" />
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 4">
      <h2>5. 会話インタフェースの紐づけ</h2>
      シナリオとインターフェース（電話番号）を紐づける
      <ol>
        <li>
          Commubo左メニューより設定>会話インタフェース<br>
          5ページ目あたりのインタフェース名「スマートチェックアウト～」の中から一つを選び「詳細」>「編集」を押して変更する
          <table class="table table-striped">
            <tbody>
            <tr>
              <td>会話インタフェース名</td>
              <td>{{ interfaceName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(interfaceName)" /></td>
            </tr>
            <tr>
              <td>着信シナリオ名</td>
              <td>{{ scenarioName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(scenarioName)" /></td>
            </tr>
            <tr>
              <td>着信対応AIオペレータ名</td>
              <td>{{ operatorName }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(operatorName)" /></td>
            </tr>
            </tbody>
          </table>
        </li>
      </ol>
    </div>

    <label class="control-label" v-if="currentStep >= 4">Commubo</label>
    <div class="row" v-if="currentStep >= 4">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="会話インタフェースID" v-model="interfaceId" />
      </div>
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input class="form-control" type="text" placeholder="発番電話番号" v-model="interfaceTel" />
      </div>
    </div>

    <div v-if="currentStep === 5">
      <h2>6. スプレッドシート更新</h2>
      <ol>
        <li>
          <a href="https://docs.google.com/spreadsheets/d/1GNuceXzjbQfGpNgfR6FXTaSdfn1zJnO-h9zESQ189kA/edit?resourcekey=&gid=168976872#gid=168976872&range=A20" target="_blank">AIでんわ連携SS（v2）</a>に以下を記載する<br>
          <input type="text" readonly :value="opsCallV2StartTxt" />
          <input type="button" value="コピー" class="btn btn-other-action" @click="copy(opsCallV2StartTxt)" />
        </li>
      </ol>
    </div>

    <div v-if="currentStep === 6">
      <h2>7. glenfiddichへのデータ登録</h2>
      <p>v1/v2両方発番の場合</p>
      <textarea readonly class="form-control" rows="5">{{ opsCallRequestTxt }}</textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(opsCallRequestTxt)" />
      <hr style="margin: 20px 0;" />
      <p>v2のみ発番の場合</p>
      <textarea readonly class="form-control" rows="5">{{ opsCallV2OnlyRequestTxt }}</textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(opsCallV2OnlyRequestTxt)" />
      <hr style="margin: 20px 0;" />
    </div>

    <div v-if="currentStep === 7">
      <h2>8. paylight X加盟店設定の更新</h2>
      <div v-if="!hasAiCallInterfaceAllFilled">
        <a href="https://docs.google.com/spreadsheets/d/1GNuceXzjbQfGpNgfR6FXTaSdfn1zJnO-h9zESQ189kA/edit?resourcekey=&gid=168976872#gid=168976872&range=A20" target="_blank">スプレッドシート（システム部連携用_AIでんわv2）</a>からA-K列を以下にコピー
        <div class="row">
          <div class="form-group col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <input class="form-control" type="text" v-model="ssRecord" />
          </div>
        </div>
      </div>
      <a :href="plxSettingListUrl" target="_blank">加盟店のX設定</a>より、

      <div v-if="!hasAiCallInterface" class="alert alert-info" style="margin-top: 10px;">
        <strong>新規開設</strong>：すべての値を新規登録する
        <ol>
          <li>
            発番電話番号（commubo）：{{ interfaceTel }}
            <input type="button" value="コピー" class="btn btn-other-action" @click="copy(interfaceTel)" />
          </li>
          <li>
            会話インターフェースID（commubo/Vonage）：{{ interfaceId }}
            <input type="button" value="コピー" class="btn btn-other-action" @click="copy(interfaceId)" />
          </li>
          <li>
            発番電話番号（Vonage）：{{ vonageTel }}
            <input type="button" value="コピー" class="btn btn-other-action" @click="copy(vonageTel)" />
          </li>
          <li>
            開始日：<b>今日</b>
          </li>
        </ol>
      </div>

      <div v-else-if="hasAiCallInterfaceAllFilled" class="alert alert-success" style="margin-top: 10px;">
        <strong>Callからの移行（全項目登録済み）</strong>：commubo/Vonageセクションの以下すべてに値が反映されていることを確認する
        <ul>
          <li>会話インタフェースID（commubo）：{{ interfaceId }}</li>
          <li>発番電話番号（commubo）：{{ interfaceTel }}</li>
          <li>会話インタフェースID（Vonage）：{{ interfaceId }}</li>
          <li>発番電話番号（Vonage）：{{ aiCallInterfaceTelV2 }}</li>
          <li>開始日：{{ aiCallInterfaceStartDate }}</li>
        </ul>
      </div>

      <div v-else class="alert alert-warning" style="margin-top: 10px;">
        <strong>Callからの移行（Vonage未登録）</strong>：発番電話番号（Vonage）以外に値が反映されていることを確認し、発番電話番号（Vonage）のみ登録して更新する
        <ol>
          <li>会話インタフェースID（commubo）：{{ interfaceId }} — <b>反映済みであること</b></li>
          <li>発番電話番号（commubo）：{{ interfaceTel }} — <b>反映済みであること</b></li>
          <li>会話インタフェースID（Vonage）：{{ interfaceId }} — <b>反映済みであること</b></li>
          <li>
            発番電話番号（Vonage） — <b>以下の値を登録する</b><br/>
            {{ vonageTel }}
            <input type="button" value="コピー" class="btn btn-other-action" @click="copy(vonageTel)" />
          </li>
          <li>開始日：{{ aiCallInterfaceStartDate }} — <b>反映済みであること</b></li>
        </ol>
      </div>
    </div>

    <div v-if="currentStep === 8">
      <h2>9. Notion更新</h2>
        <p><a :href="plxContractListUrl" target="_blank">Xの契約</a>より同期ステータスが「同期済」となっていることを確認</p>
        <p style="color: red; font-weight: bold;">※同期エラーになったり、加盟店設定の更新から5分以上経っても同期済にならない場合は、Inhouseへご連絡をお願いします。</p>

        <p>X契約システム設定作業依頼DBの作業中レコードを更新する</p>
        <ol>
          <li>
            AIでんわv1電話番号：{{ interfaceTel }}
            <input type="button" value="コピー" class="btn btn-other-action" @click="copy(interfaceTel)" />
          </li>
          <li>
            AIでんわv2電話番号：{{ aiCallInterfaceTelV2 || vonageTel }}<input type="button" value="コピー" class="btn btn-other-action" @click="copy(aiCallInterfaceTelV2 || vonageTel)" />
          </li>
          <li>
            AIでんわ通話インターフェース：{{ interfaceId }}
            <input type="button" value="コピー" class="btn btn-other-action" @click="copy(interfaceId)" />
          </li>
        </ol>

        <p>以下コメントを記載の上、Notionの「対応完了」ボタンを押下する。<br/>
          Notionのステータスが「完了」となることを確認して、作業完了です。<br/>
          ※「対応完了」すると依頼者へ通知がいくとのことなので、slack等での完了報告も基本不要
        </p>

      <hr style="margin: 20px 0;" />
      <p>v1/v2両方発番の場合</p>
      <textarea readonly :value="finishReportTxt" class="form-control" rows="3"></textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(finishReportTxt)" />
      <hr style="margin: 20px 0;" />
      <p>v2のみ発番の場合</p>
      <textarea readonly :value="finishReportOnlyV2Txt" class="form-control" rows="4"></textarea>
      <input type="button" value="コピー" class="btn btn-other-action" @click="copy(finishReportOnlyV2Txt)" />
      <hr style="margin: 20px 0;" />
    </div>

    <button class="btn btn-other-action" @click="beforeStep">前工程</button>
    <button v-if="currentStep < 8" class="btn btn-other-action" @click="nextStep">次工程</button>
  </div>
</template>

<style scoped>
</style>

<script>
const plans = [
  { title: 'ライト' },
  { title: 'スタンダード' },
  { title: 'メガ' },
  { title: 'エンタープライズ' },
]
const options = [
  { title: 'カスタムシナリオ利用', key: 'customScenario' },
  { title: '独自シナリオ製作・利用', key: 'originalScenario' },
  { title: 'コールセンター転送', key: 'callCenterTransfer' },
  { title: '予約システムURL送付SMS', key: 'sms' },
  { title: 'LINEオプション', key: 'line' }
]
const operators = [
  { name: '標準', commubo: 'AIロボットのコミュボ-女性(ハキハキした声)' },
  { name: '高級向け', commubo: '高級向け - 女性(ハキハキした声)' },
  { name: '高齢者向け', commubo: '高齢者向け - 女性(ハキハキした声)' }
]

export default {
  data() {
    return {
      currentStep: 0,
      plans,
      options,
      operators,
      callCenterCheckIdx: options.findIndex(opt => opt.key === 'callCenterTransfer'),
      smsCheckIdx: options.findIndex(opt => opt.key === 'sms'),
      lineCheckIdx: options.findIndex(opt => opt.key === 'line'),
      checkedOptions: Array(options.length).fill(false),
      selectedPlan: '',
      selectedOperator: '高級向け',
      startHopeDate: '',
      name: '',
      nameRuby: '',
      notionName: '',
      sfOpportunityId: '',
      notionInput: '',
      shopId: '',
      phone: '',
      address: '',
      interfaceTel: '',
      interfaceId: '',
      settingCallCenterTransfer: false,
      follow: '',
      ssRecord: '',
      contractSpreadsheet: '',
      requestCategory: '',
      aiCallContractId: null,
      aiCallSfOpportunityId: null,
      aiCallPlanStartDate: null,
      aiCallPlanEndDate: null,
      appDate: new Date().toISOString().split('T')[0],
      hasAiCallInterface: false,
      hasAiCallInterfaceAllFilled: false,
      aiCallInterfaceTelV2: '',
      aiCallInterfaceStartDate: ''
    }
  },
  computed: {
    aiCallPlanStatus() {
      if (!this.aiCallContractId) return 'none'
      const today = new Date().toISOString().split('T')[0]
      if (this.aiCallPlanStartDate <= today && (!this.aiCallPlanEndDate || this.aiCallPlanEndDate >= today)) {
        return 'active'
      }
      return 'ended'
    },
    scenarioName() {
      const scenarioNameSuffix = '【カレンダー連携】gpt'
      return `${this.name}${this.shopId}${this.selectedPlan}${scenarioNameSuffix}`
    },
    interfaceName() {
      return `${this.name}${this.shopId}`
    },
    operatorName() {
      const operator = this.operators.find(op => op.name === this.selectedOperator)
      return operator ? operator.commubo : '未選択'
    },
    gcManagementTxt() {
      return `${this.shopId}\t${this.name}\t${this.nameRuby}\t${this.phone}\t${this.address}\t${this.interfaceTel}`
    },
    plxSettingListUrl() {
      return `/manage/store_platform_settings?shop_id=${this.shopId}`
    },
    opsCallV1StartTxt() {
      const today = new Date().toISOString().split('T')[0].replace(/-/g, '/')
      const status = 'システム部依頼中'
      return `=ROW()-3\t${this.shopId}\t${this.name}\t${this.interfaceId}\t${this.interfaceTel}\t${today}\t${status}`
    },
    opsCallV2StartTxt() {
      const today = new Date().toISOString().split('T')[0].replace(/-/g, '/')
      const type = 'v1/v2共存'
      const status = 'OPS依頼中'
      return `=ROW()-1\t${type}\t${status}\t${this.shopId}\t${this.name}\t${this.nameRuby}\t${this.interfaceId}\t${this.interfaceId}\t${this.interfaceTel}\t${today}`
    },
    opsCallRequestTxt() {
      return '@ops No.**のAIでんわ(v1/v2)連携作業をお願いします。'
    },
    opsCallV2OnlyRequestTxt() {
      return [
        '@ops No.**のAIでんわ(v2)連携作業をお願いします。',
        'v1は連携済となりますので、v2のみご対応をお願いします。'
      ].join('\n')
    },
    vonageTel() {
      const ssArray = this.ssRecord.split('\t')
      return ssArray[10] // K列: Vonage電話番号(v2)
    },
    callCenterTransferCheckHtml() {
      return `コールセンター転送が設定されているかどうかを以下から確認。<br/>`
        + `<a href="/manage/store_ai_call_contracts/${this.aiCallContractId}/workflows/new" target="_blank">Call契約詳細</a> > オプション<br/>`
        + `<a href="https://docs.google.com/spreadsheets/d/1ph_UsTjeN8STsY5tRoDV06dAo6l-6xEQn62nlf3ZDIM/edit?gid=66450166#gid=66450166" target="_blank">SCO×グッドクロス管理表</a> > シートをShopIDで検索<br/>`
        + `commuboの<a href="https://console.commubo.com/scenarios" target="_blank">会話シナリオ一覧</a>よりShopIDで検索>詳細・削除>最新バージョンの参照ボタン>医院情報設定ノードからtransferパラメータの値を確認（パラメータが空でなければ転送設定あり）`
    },
    sfCallCheckHtml() {
      return `salesforceのCall商談を確認<br/>`
        + `当該加盟店のSFCall商談 > 申し込み情報 > メールアドレスが登録されていたら、削除して保存。<br/>`
        + `ここにメールアドレスが登録されたままだと、Callの解約メールが送付されてしまうため。<br/>`
        + `削除したメールアドレスは、念の為控えておいてNotionにコメントで残しておくと安心です。`
    },
    callEndedNoticeTxt() {
      return [
        `過去にpaylight Callの契約が存在しており（${this.aiCallPlanStartDate} 〜 ${this.aiCallPlanEndDate}）、AIでんわv1は発番済みです。`,
        `v1については、Call契約時に使用していた発番番号、及びシナリオを再利用しますか？`
      ].join('\n')
    },
    callMigrationNoticeTxt() {
      return [
        `${this.aiCallPlanStartDate}より稼働中のpaylight Callの契約が存在しています。`,
        `ステータスを「Callからの移行」に変更の上、以下のフォーマットで乗せ替えタイミングをお知らせください。`,
        ``,
        `①yyyy-mm-dd Call解約`,
        `②yyyy-mm-dd~yyyy-mm-ddの契約をCallの料金設定を踏襲してXに乗せ替え`,
        `③yyyy-mm-ddから正規のX料金で契約`,
        ``,
        `※②については必要な場合のみ。不要であればその旨明記してください。`,
        ``
      ].join('\n')
    },
    newContractConfirmNoticeTxt() {
      return [
        `過去にpaylight Callの契約が存在しません。`,
        `新規開設として処理してよろしいでしょうか？`
      ].join('\n')
    },
    callCenterSettingNoticeTxt() {
      return [
        `最新シナリオにてコールセンター転送設定がされています。`,
        `こちらX契約においても`,
        `①利用を継続するかどうか`,
        `②また請求対象とするかどうか`,
        `ご確認をお願いいたします。`
      ].join('\n')
    },
    callCenterSettingNoticeHtml() {
      const escaped = this.callCenterSettingNoticeTxt.replace(/\n/g, '&#10;')
      return `<p>コールセンター転送設定があった場合は、サクセスから申し送り事項がなければ以下コメントも添えて差し戻し</p>`
        + `<textarea readonly class="form-control" rows="6">${escaped}</textarea>`
    },
    finishReportTxt() {
      return [
        `X契約およびAIでんわv1/v2発番が完了しました。`,
        `医院さまと発話内容のご確認をお願いいたします。`,
      ].join('\n')
    },
    finishReportOnlyV2Txt() {
      return [
        `X契約およびAIでんわv2発番が完了しました。`,
        `v1は連携済のため、v2のみ新規発番しております。`,
        `医院さまと発話内容のご確認等お願いいたします。`,
      ].join('\n')
    },
    checkedOnCallCenterTransfer() {
      return this.checkedOptions[this.callCenterCheckIdx]
    },
    checkedOnSms() {
      return this.checkedOptions[this.smsCheckIdx]
    },
    checkedOnLine() {
      return this.checkedOptions[this.lineCheckIdx]
    },
    plxContractListUrl() {
      return `/manage/store_platform_contracts?shop_id=${this.shopId}`
    },
  },
  methods: {
    beforeStep() {
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },
    nextStep() {
      if (this.currentStep < 9) {
        this.currentStep++
      }
    },
    loadSfOpportunity() {
      if (!this.sfOpportunityId) {
        alert('商談IDを入力してください。')
        return
      }

      console.log(`Loading SF Opportunity with ID: ${this.sfOpportunityId}`)

      const unixtime = Math.floor(Date.now() / 1000)
      fetch(`/api/v1/sfo_call/?id=${this.sfOpportunityId}&tv=${unixtime}`)
          .then(response => {
            if (!response.ok) throw new Error('データ取得に失敗しました')
            return response.json()
          })
          .then(data => {
            this.shopId = data.shopId || ''
            this.name = data.name || ''
            this.nameRuby = data.nameRuby || ''
            this.phone = data.phone || ''
            this.address = data.address || ''
            this.startHopeDate = data.startHopeDate || ''

            this.selectedOperator = data.operator || ''
            this.selectedPlan = data.plan || ''
            this.options.forEach((opt, idx) => {
              this.checkedOptions[idx] = data.options[opt.key] || false
            })
            this.settingCallCenterTransfer = data.settings.callCenterTransfer
            this.follow = data.follow

            const makeContractSpeadsheetSentence = (data) => {
              const today = new Date().toISOString().split('T')[0]
              const contractFullName = data.contractName[0] + ' ' + data.contractName[1]
              const zipCode = data.sAddress[0]
              const state = data.sAddress[1]
              const city = data.sAddress[2]
              const street = data.sAddress[3]
              const building = data.sAddress[4]
              const fullAddress = `${state}${city}${street}${building}`

              const owner = data.owner

              const contractNamePart = `${data.contractName[0]}\t${data.contractName[1]}\t${contractFullName}`
              const addressPart = `${zipCode}\t${state}\t${city}\t${street}\t${building}\t${fullAddress}`
              return `${today}\t${this.appDate}\t${this.name}\t${contractNamePart}\t${data.sPhone}\t${addressPart}\t${this.shopId}\t${this.follow}\t${owner}\t${this.sfOpportunityId}`
            }
            this.contractSpreadsheet = makeContractSpeadsheetSentence(data)
          })
          .catch(error => {
            alert(error.message)
          })
    },
    loadShopId() {
      if (!this.notionInput) {
        alert('Notionコピー項目を入力してください。')
        return
      }

      const columns = this.notionInput.split('\t')
      if (columns.length < 3) {
        alert('入力形式が正しくありません。Notionからタブ区切りでコピーしてください。')
        return
      }

      this.appDate = columns[0].trim()
      this.notionName = columns[1].trim()
      this.shopId = columns[2].trim()
      this.follow = columns[3].trim()
      if (columns.length >= 8) {
        this.nameRuby = columns[7].trim()
      }
      if (columns.length >= 9) {
        this.requestCategory = columns[8].trim()
      }
      this.fetchStoreData()
    },
    loadByShopId() {
      if (!this.shopId) {
        alert('SHOP IDを入力してください。')
        return
      }
      this.fetchStoreData()
    },
    fetchStoreData() {
      console.log(`Loading store data with ID: ${this.shopId}`)

      fetch(`/api/v1/store_data/?shop_id=${this.shopId}`)
          .then(response => {
            const contentType = response.headers.get('content-type') || ''
            if (!contentType.includes('application/json')) {
              throw new Error('セッションが切れています。ページをリロードしてログインし直してください。')
            }
            if (!response.ok) {
              return response.json().then(body => {
                throw new Error(body.error || 'データ取得に失敗しました')
              })
            }
            return response.json()
          })
          .then(data => {

            this.name = data.name || ''
            this.aiCallContractId = data.aiCallContractId || null
            this.aiCallSfOpportunityId = data.aiCallSfOpportunityId || null
            this.aiCallPlanStartDate = data.aiCallPlanStartDate || null
            this.aiCallPlanEndDate = data.aiCallPlanEndDate || null
            // interface_idがあればtel_v1も必ず存在する。OR条件はAPIレスポンス欠落時の防御用
            this.hasAiCallInterface = !!(data.aiCallInterfaceId || data.aiCallInterfaceTel)
            // Callからの移行の場合、tel_v1, interface_id, start_dateは必ず値が入っている
            // tel_v2の有無で全項目登録済みかどうかを判定する
            this.hasAiCallInterfaceAllFilled = !!data.aiCallInterfaceTelV2
            if (data.aiCallInterfaceId) this.interfaceId = data.aiCallInterfaceId
            if (data.aiCallInterfaceTel) this.interfaceTel = data.aiCallInterfaceTel
            this.aiCallInterfaceTelV2 = data.aiCallInterfaceTelV2 || ''
            this.aiCallInterfaceStartDate = data.aiCallInterfaceStartDate || ''

            if (this.notionName && this.name && this.notionName !== this.name) {
              alert(`Notion医院名「${this.notionName}」とDB医院名「${this.name}」が一致しません。SHOP IDを確認してください。`)
            }

            const makeContractSpeadsheetSentenceByShopId = (data) => {
              const today = new Date().toISOString().split('T')[0]
              const contractFullName = data.contactLastName + ' ' + data.contactFirstName
              const zipCode = data.zipCode
              const state = data.state
              const city = data.city
              const street = data.street
              const building = data.building
              const fullAddress = `${state}${city}${street}${building}`

              const contractNamePart = `${data.contactLastName}\t${data.contactFirstName}\t${contractFullName}`
              const addressPart = `${zipCode}\t${state}\t${city}\t${street}\t${building}\t${fullAddress}`
              return `${today}\t${this.appDate}\t${this.name}\t${contractNamePart}\t${data.phone}\t${addressPart}\t${this.shopId}\t${this.follow}`
            }
            this.contractSpreadsheet = makeContractSpeadsheetSentenceByShopId(data)
          })
          .catch(error => {
            alert(error.message)
          })
    },
    copy(text) {
      navigator.clipboard.writeText(text)
    }
  }
}
</script>